import * as React from 'react';
import { useContext } from 'react';
import { Slide, ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import GlobalContext from '../_contexts/GlobalContext';

export interface IShowToastComponentProps {
  message: string;
  isError?: boolean;
  timeout?: number;
  callback: Function;
}

const ShowToastComponent : React.FunctionComponent<IShowToastComponentProps> = (props : IShowToastComponentProps) => {
  const { IsMobile } = useContext(GlobalContext);

  if (props.message?.length) {
    if (props.isError) {
      toast.error(props.message);
    } else {
      toast.info(props.message);
    }
    
    props.callback();
  }

  return(
      <ToastContainer style={{borderRadius: "5px", left: "auto", width: IsMobile ? "300px" : "500px"}}
                      autoClose={props.timeout ? props.timeout : 1000} 
                      position={IsMobile ? 'bottom-right'  : 'bottom-right'  }
                      newestOnTop={true} 
                      limit={4} 
                      transition={Slide} />
  );
}

export default ShowToastComponent;
